import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
import logger from '@/utils/logger';
import envConfig from '@/config/environment';
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};
export const FIREBASE_CLIENT_ID = process.env.NEXT_PUBLIC_FIREBASE_CLIENT_ID; // Ensure that these requested scopes are covered in the
// process to verify Google OAuth scope access here:
// ./docs/firebaseSetup.md "Verify App For Google OAuth"

export const googleOauthScopes = ['https://www.googleapis.com/auth/drive.file', 'https://www.googleapis.com/auth/drive.metadata.readonly', 'https://www.googleapis.com/auth/drive.readonly'];

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const app = firebase.app();
const auth = firebase.auth();
const db = firebase.firestore();
const now = firebase.firestore.Timestamp.now();
const storage = firebase.storage();
const functions = firebase.functions();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
googleOauthScopes.forEach(scope => {
  googleAuthProvider.addScope(scope);
}); //// Uncomment the following line to let functions use the functions emulator
// if (process.env.NODE_ENV === 'development') {
//   functions.useFunctionsEmulator('http://localhost:5001');
// }
//// Uncomment the following line to let functions use the database emulator
// if (process.env.NODE_ENV === 'development') {
//   db.settings({ host: 'localhost:8080', ssl: false });
// }

export { auth, db, functions, now, storage, googleAuthProvider };

if (envConfig.isDevelopment) {
  logger.info(app.name ? 'Firebase Mode Activated!' : 'Firebase not working :(');
}